import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { getNorthbeamUtmPlatformTitle } from "../constants";

import { PlatformComponent } from "./platform-component";
import { UtmAccordion } from "./utm-accordion";

export const NorthbeamUtms = (): JSX.Element => (
  <div className="northbeam-utms">
    <h4 className="heading mx-0 mb-3 mt-0">Northbeam UTMs</h4>
    <UtmAccordion
      data={Object.values(NorthbeamUtmPlatform).map((platform, i) => ({
        title: getNorthbeamUtmPlatformTitle({ platform }),
        content: <PlatformComponent key={i} platform={platform} />,
      }))}
    />
  </div>
);
